import NoContent from './NoContent';
import NoContentWrapper from './components/NoContentWrapper';

export { NoContentWrapper };
export default NoContent;
